import React from "react";

const infoData = [
  {
    title: "Government-Backed Projects",
    content:
      "In partnership with NIDCOM, every listing carries official oversight. ",
    img: "/assets/images/government-fill.svg",
  },
  {
    title: "Verified Title Documents",
    content: "Every listing is thoroughly checked",
    img: "/assets/images/verified-badge.svg",
  },
  {
    title: "Money-Back Guarantee",
    content: "Money back Guarantee on buyers  dissatisfactions",
    img: "/assets/images/money.svg",
  },
];

const Info = () => {
  return (
    <div className="w-full px-8 flex py-5 items-center justify-center">
      <div className="max-w-[1163px] w-full items-center flex flex-col gap-6 md:gap-10">
        {/* <div className="flex md:flex-row flex-col items-center gap-[50px] w-full">
          <div className="w-full md:w-1/2 flex gap-5 items-start p-5 rounded-lg bg-textWhite shadow-custom">
            <div className="w-[44px]">
              <div className="rounded-full w-[44px] h-[44px] bg-primary/10 flex items-center justify-center">
                <img src="/assets/images/home-verified.svg" alt="" />
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <h3 className="text-textBlack font-medium font-poppins text-[22px] md:text-[28px]">
                Verified Properties
              </h3>
              <span className="text-[14px] text-textBlack">
                Every property on Home & Abroad goes through strict checks.
                Titles are reviewed, developers are vetted, and each listing is
                government-approved.
              </span>
            </div>
          </div>
          <div className="w-full md:w-1/2 flex gap-4 items-start p-5 rounded-lg bg-textWhite shadow-custom">
            <div className="w-[44px]">
              <div className="rounded-full w-[44px] h-[44px] bg-primary/10 flex items-center justify-center">
                <img src="/assets/images/transaction.svg" alt="" />
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <h3 className="text-textBlack font-medium font-poppins text-[22px] md:text-[28px]">
                Secure Payments
              </h3>
              <span className="text-[14px] text-textBlack">
                Your money is safe fro start to finish. We use encrypted payment
                systems built for Nigerians abroad, so you can invest without
                fear of fraud or third party interference.
              </span>
            </div>
          </div>
        </div> */}
        <div className="w-full flex md:flex-row flex-col gap-5 pb-8">
          {infoData.map((info, index) => (
            <div
              key={index}
              style={{
                boxShadow: " 0px 1px 2px 0px #87CEEB4D",
              }}
              className="w-full p-[30px] rounded-[14px] lg:w-1/3 gap-6 flex items-center jstify-center flex-col"
            >
              <div className="rounded-full w-[100px] h-[100px] bg-primary/10 flex items-center justify-center">
                <img src={info.img} alt={info.title} />
              </div>
              <span className="text-center text-textBlack text-[22px] font-poppins font-semibold">
                {info.title}
              </span>
              {/* <span className="text-textBlack text-center">{info.content}</span> */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Info;
